// index

let dt_index = null;
let dt_groups = null;
let dt_log = null;

export function index(params){

    dt_index = $('#users_table').DataTable({
        ajax: {
            url: $('#users_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_users_actions },
            { data: 'username', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
            { data: 'surname', orderable: true, searchable: true },
            { data: 'email', orderable: true, searchable: true },
        ],
        order: [[3, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_users"]').click(batch_delete_user);
        $(settings.nTableWrapper).find('.table_batch_actions [action="activate_users"]').click(batch_activate_user);
        $(settings.nTableWrapper).find('.table_batch_actions [action="block_users"]').click(batch_block_user);
        
        window.forms.init();
        
    });

    dt_index.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.update_active').click(update_active);
    });
}

export function filter_microsites(data){

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name + '<small class="d-block font-weight-light">' + obj.url + "</small>"
        };
    });

    return {
        results: [{id: 0, text: '&nbsp;'}].concat(results) 
    };

}

function batch_delete_user(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['admin.users.batch_delete'];
    
    let users_id = [];
    $.each(rows_selected, function(index, rowId){
        users_id.push(rowId);
    });
    
    if(users_id.length == 0){

        window.messages.error(__('No has seleccionado ningún usuario'));

    } else {

        const title = __('Eliminar usuarios');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un usuario.|[2,*] Estás a punto de eliminar :count usuarios.', users_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let user_id of users_id){
                        formData.append('users_id[]', user_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function batch_activate_user(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    return batch_update_active_status(table, true);
}

function batch_block_user(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    return batch_update_active_status(table, false);
}

function batch_update_active_status(table, active){

    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['admin.users.batch_update_active'];
    
    let users_id = [];
    $.each(rows_selected, function(index, rowId){
        users_id.push(rowId);
    });
    
    if(users_id.length == 0){

        window.messages.error(__('No has seleccionado ningún usuario'));

    } else {

        let formData = new FormData();
        for(let user_id of users_id){
            formData.append('users_id[]', user_id);
        }
        formData.append('active', active ? 1 : 0);

        window.forms.post(route, formData);

    }

}

function render_users_actions(data, type, row){

    const url_info = ($("#users_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '   <a class="btn ' + (row.active ? 'btn-success' : 'btn-danger') + ' btn-xs '+ (row.id != window._user_id ? 'update_active' : '') +'" user_id="' + row.id + '" active="' + row.active +'" >' + (row.active ? window.__('activo') : window.__('bloqueado')) + '</a>' +
        '</div>';

    return actions;

}

export function update_active(){

    const user_id = $(this).attr('user_id');
    const active = $(this).attr('active') == 'true';
    const route = window._routes['admin.users.update_active'].replace('{user_id}', user_id);

    let formData = new FormData();
    formData.append('active', active ? 0 : 1);
    
    window.forms.post(route, formData);

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

// show

export function show(){

    // update profile image

    $('#user_update_profile_image .profile_image_preview').click(function(){
        $('#user_update_profile_image input[name="profile_image"]').trigger('click');
    });

    init_groups();
    init_permissions();

    // datatable logs
    
    // dt_log = $('#logs_table').DataTable({
    //     ajax: {
    //         url: $('#logs_table').attr('url'),
    //     },
    //     columns: [
    //         { width: 120, data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime_seconds },
    //         { data: 'action', orderable: false, searchable: false },
    //         { data: 'model', orderable: false, searchable: true, render: datatables.render_small_newline },
    //         { data: 'model_friendly', orderable: false, searchable: true, render: datatables.render_small_newline },
    //         { data: 'changes', orderable: false, searchable: true, render: datatables.render_array },
    //     ],
    //     order: [[0, 'desc']],
    // });

    // dt.on('init', function(e, settings, json){
    // });

    // dt.on('draw', function(e, settings){
    // });

}

// profile image

export function update_profile_image(params){

    if(
        typeof params != 'undefined' 
        && typeof params.preview != 'undefined'
        && typeof params.thumb != 'undefined'
    ){

        if(params.is_me){
            
            $('.profile_image_thumb').attr('src', params.thumb);
            $('.profile_image_preview').attr('src', params.preview);

        } else {

            $('#user_update_profile_image .profile_image_thumb').attr('src', params.thumb);
            $('#user_update_profile_image .profile_image_preview').attr('src', params.preview);

        }
        
        const blank = params.blank || false;
        if(!blank){
            $('[type="submit"][name="user_delete_profile_image"]').removeClass('d-none');
        } else {
            $('[type="submit"][name="user_delete_profile_image"]').addClass('d-none');
        }

    }

    $('#user_update_profile_image input[name="profile_image"]').val('');
    $('#user_update_profile_image input[name="profile_image"]').closest('.custom-file').find('label').html('');

}

// update password

export function reset_password_form(){
    $('#user_update_password input').val('');
}

function init_groups() {
    // datatable user_groups
        
    dt_groups = $('#user_groups_table').DataTable({
        ajax: {
            url: $('#user_groups_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_users_group_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_users_group_actions(data, type, row) {
    const url_info = ($("#user_groups_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

export function filter_groups(data){

    return {
        results: $.map(data.results, function(obj, index) {
            // let user = obj.username + '<small class="d-block font-weight-light">' + obj.name + ' ' + (obj.surname != null ? obj.surname : '') + "</small>";
            let group = obj.name;
            return { 
                id: obj.id,
                text: obj.name,
                result: group
            };
        })
    };
}

function init_permissions() {
    // datatable user_microsites_roles
        
    dt_groups = $('#user_microsites_table').DataTable({
        ajax: {
            url: $('#user_microsites_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_users_microsite_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'dominio', orderable: true, searchable: true },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_users_microsite_actions(data, type, row) {
    const url_info = ($("#user_microsites_table").attr('url_info') ?? '').replace('#', row.subject_id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}